/**
 * @file     articleAttribution.ts
 * @purpose  Honest byline rules shared by the blog UI and the Article schema.
 *           A hand-written post is Ray's. An engine or commentary post is
 *           assembled by the platform, so the Organization is the author until
 *           Ray has reviewed it; after review Ray is named as reviewer, not
 *           author. Client-safe: constants only.
 */
import { brandConfig } from './brandConfig';

/** Post provenance values that are machine-assembled rather than hand-written. */
export const MACHINE_POST_SOURCES = new Set(['engine', 'rss-commentary']);

export interface ArticleAttribution {
  author: { kind: 'person'; name: string; href: string } | { kind: 'organization'; name: string };
  /** Set once a human has reviewed a machine-assembled post. */
  reviewedBy: { name: string; href: string } | null;
}

export function resolveArticleAttribution(post: {
  source?: string | null;
  reviewedAt?: string | null;
}): ArticleAttribution {
  const ray = { name: brandConfig.agentName, href: `${brandConfig.websiteBaseUrl}/about-ray` };
  if (!MACHINE_POST_SOURCES.has(post.source ?? 'manual')) {
    return { author: { kind: 'person', ...ray }, reviewedBy: null };
  }
  return {
    author: { kind: 'organization', name: brandConfig.companyDisplayName },
    reviewedBy: post.reviewedAt ? ray : null,
  };
}
